enum BoundingAxis {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
}

export { BoundingAxis }
